import { Typography } from '@epilot/concorde-elements'
import type { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

import classes from './AttributeItem.module.scss'

type AttributeItemProps = {
  label: string
  value: string | string[] | null
  slug?: string
  displayMode?: 'simple' | 'table'
}

export const AttributeItem = ({
  label,
  value,
  slug,
  displayMode
}: AttributeItemProps) => {
  const { t: tEntity } = useTranslation('entity')
  const { t } = useTranslation()

  if (value === null) {
    return null
  }

  if (Array.isArray(value)) {
    return (
      <>
        {value.map((v, i) => (
          <SimpleAttributeItem
            displayMode={displayMode}
            key={'address' + i}
            label={getTranslation(t, tEntity, `attributes.${label}`, label)}
            value={v}
          />
        ))}
      </>
    )
  }

  const valueKey = `${slug}.${label.toLowerCase()}.${value}`
  const translatedLabel = getTranslation(
    t,
    tEntity,
    `attributes.${label}`,
    label
  )

  return (
    <SimpleAttributeItem
      displayMode={displayMode}
      label={translatedLabel || label}
      value={value ? getTranslation(t, tEntity, valueKey, value) : ''}
    />
  )
}

export const SimpleAttributeItem = ({
  label,
  value,
  displayMode
}: AttributeItemProps) => {
  return displayMode === 'simple' ? (
    <Typography>
      {label}: {value}
    </Typography>
  ) : (
    <div className={classes.item}>
      <span>
        <Typography className={classes.label}>
          {(label || '').toUpperCase()}
        </Typography>
      </span>
      <span>
        <Typography className={classes.value}>{value || '-'}</Typography>
      </span>
    </div>
  )
}

const getTranslation = (
  t: TFunction,
  tEntity: TFunction,
  valueKey: string,
  value: string
) => {
  const alternateKey = `selectvalues.${valueKey}`

  return tEntity(valueKey, tEntity(alternateKey, t(valueKey, value)))
}
